import React, { Component } from 'react';
import './style.scss';
import { connect } from 'react-redux'
import { getPresentation, getParams } from './actions';
import QRCode from 'qrcode.react';
import Spiner from '../helpers/Spiner/Spiner';
import PropTypes from 'prop-types'
import history from '../../history';
import {toastr} from 'react-redux-toastr';
import moment from 'moment';

class PresentationsStart extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      presentation: {},
      loaded: false,
      session: {},
      count_student: 0,
      token_teacher: '',
      token_student: '',
      token_proector: '',
    }
    this.timer = null;
  }
  
  async componentDidMount(){
    const {formatMessage} = this.context;
    try {
      const {presentation, session, token_proector, token_teacher, token_student} = await getPresentation(this.props.match.params.id);
      const params = await getParams();
      this.setState({
        presentation,
        loaded: true,
        session,
        site: params.presentationSite,
        urlApi: params.presentationApi,
        token_teacher,
        token_student,
        token_proector,
      });


      fetch(params.presentationApi + '/api/presentations/redirect_presentation', {
        method: 'POST', 
        body: JSON.stringify({id: presentation.id})})
      .then(res => res.json())

      clearInterval(this.timer);

      this.timer = setInterval(async () => {

        try {
          let result = await fetch(params.presentationApi + '/api/presentations/count_connect_presentation', 
            {method: 'POST', body: JSON.stringify({id: presentation.id, session_id: session.id})}).then(res => res.json())
          this.setState({count_student: result.count})
        } catch (error) {
          
        }
      }, 1500);

    } catch (error) {
      toastr.error(formatMessage('errorStartPresentation'), formatMessage('errorStartPresentationNotItems'))
      history.push('/presentations');
    }
    
  }

  componentWillUnmount(){
    clearInterval(this.timer)
  }

  actionPresentation = () => {
    const {presentation, loaded, site, urlApi, session, token_teacher} = this.state;
    this.setState({loaded: false});
    const isMobile = this.isMobile();
    fetch(urlApi + '/api/presentations/start?session=' + session.id + '&date=' + moment().format('MM-DD-YYYY h:mm a')).then(response => {
      if(response.status == 200){
        
        if(isMobile){
          location.href = site + '/presentation/' + token_teacher;
        } else {
          const link = document.getElementById('link_presentation');
          console.log("🚀 ~ file: PresentationsStart.jsx:81 ~ PresentationsStart ~ fetch ~ link:", link)
          if(link){
            link.click();
          }
        }
        setTimeout(() => {
          history.push('/presentations')
        }, 2000);
        // history.push('/presentations')
      } else {
        this.setState({loaded: true});
      }
    })
  }

  isMobile(){
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }


  viewCode = () => {
    const {presentation} = this.state;
    let tmp = presentation.code;
    let result = '';

    while (tmp.length/3 >= 2) {
      result += tmp.slice(0, 3) + '&nbsp&nbsp';
      tmp = tmp.slice(3, tmp.length)
    }
    return result + tmp;
  }

  render() {
    const {presentation, loaded, site, count_student,  
      token_teacher,
      token_student,
      token_proector,
      session,
    } = this.state;

    const {formatMessage} = this.context;
    const {profile} = this.props;
    if(!loaded){
      return <React.Fragment>
        <a id="link_presentation" style={{display: 'none'}}  href={site + '/presentation/' + token_teacher} target="_blank">presentation</a>
        <Spiner/>
      </React.Fragment>;
    }

    const isMobile = this.isMobile();

    return (
      <div className="qbm-content PresentationsStart"> 
        <h2>{presentation.name}</h2>
        <p style={{fontSize: 25, fontWeight: 'bold'}}>{site} </p>
        <p>{formatMessage('enterCode')}</p>
        <div className="code"  dangerouslySetInnerHTML={{__html: this.viewCode()}}></div>
        <p style={{fontWeight: 'bold'}}>{formatMessage('presentationPassword')}</p>
        <div className="code">{session.password}</div>
        <p>{formatMessage('scanQrCode')}</p>
        <div style={{marginBottom: '10px'}}>
          <QRCode value={site + '/presentation/' + token_student} size={300} />
        </div>
        <div className="active-student">
          <div>{count_student} students joined this session</div>
        </div>
        <div>
          <button type="button" className="btn btn-success" onClick={() => {
            this.actionPresentation();
          }}><i className="fas fa-play" style={{marginRight: 10,}}></i>{formatMessage('btnTxtStartPresentation')}</button>
          <input style={{opacity: 0, position: 'absolute', zIndex: -1, width: 1}} value={site + '/presentation/' + token_student} id="presentation_url" />
          <button type="button" className="btn btn-success" style={{marginLeft: 10}} onClick={() => {
             var copyText = document.getElementById("presentation_url");
             copyText.select();
             copyText.setSelectionRange(0, 99999); 
             document.execCommand("copy");
             toastr.success(formatMessage('copyLinkPresentation'), formatMessage('copyLinkPresentationMsg'))
          }}><i className="fas fa-link"></i> {formatMessage('copyLinkPresentationBtn')}</button>
        </div>
       
        <a id="link_proector" style={{display: 'none'}}  href={site + '/presentation/' + token_proector} target={'_blank'}>proector</a>
        <div>
          <button type="button"  className="btn btn-info" style={{marginTop: 20}} onClick={() => {
            try {
              const h = window.window.screen.height - 400; 
              const w = window.screen.width - 400; 
    
              const y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
              const x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);

              var deviceAgent = navigator.userAgent;
              // Set var to iOS device name or null
              var ios = deviceAgent.toLowerCase().match(/(iphone|ipod|ipad)/);
            
              if (ios) {
                const link = document.getElementById('link_proector');
                if(link){
                  link.click();
                }
              } else {
                window.open(site + '/presentation/' + token_proector, 'proector', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+y+', left='+x);
              }
            } catch (error) {
              
            }
          }}><i className="fas fa-tv" style={{marginRight: 10,}}></i>{formatMessage('btnTxtOpenPageProector')}</button>
          <input style={{opacity: 0, position: 'absolute', zIndex: -1, width: 1}} value={site + '/presentation/' + token_proector} id="proector_url" />
          <button type="button" className="btn btn-info" style={{marginTop: 20,  marginLeft: 10}} onClick={() => {
             var copyText = document.getElementById("proector_url");
             copyText.select();
             copyText.setSelectionRange(0, 99999); 
             document.execCommand("copy");
             toastr.success(formatMessage('copyLinkProector'), formatMessage('copyLinkProectorMsg'))
          }}><i className="fas fa-link"></i> {formatMessage('copyLinkProectorBtn')}</button>

        </div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  profile: state.profile.entity,
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(PresentationsStart)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/PresentationsStart/PresentationsStart.jsx